import React from 'react';
import { TapeMeasureAI } from './components/TapeMeasureAI';
export function App() {
  return <TapeMeasureAI data-id="element-0" />;
}